/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import deleteBureauxActions, {
    deleteBureauTypes,
} from '../../../redux/bureau/deleteBureau'
import getAllBureauxActions from '../../../redux/bureau/getAllBureaux'
import { Delete } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* deleteBureauSagas(response) {
    try {
        const responseDelete = yield Delete(
            `bureauemploi/${response.response.id}`
        )
        if (responseDelete.status === 200 || responseDelete.status === 201) {
            yield all([
                yield put(
                    getAllBureauxActions.getAllBureauxRequest()
                ),
                yield put(
                    deleteBureauxActions.deleteBureauSuccess(
                        responseDelete.data
                    )
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
                yield put(
                    getAllBureauxActions.getAllBureauxRequest()
                ),
            ])
        } else {
            yield put(
                deleteBureauxActions.deleteBureauFailure(
                    responseDelete.data
                )
            )
        }
    } catch (error) {
        yield put(deleteBureauxActions.deleteBureauFailure(error))
    }
}

export function* deleteBureauSaga() {
    yield takeLatest(
        deleteBureauTypes.DELETE_BUREAU_REQUEST,
        deleteBureauSagas
    )
}
